import { ErrorInfo } from 'react';
import { HashRouter } from 'react-router-dom';
import { BaseComponent } from './components/core/BaseComponent';
import { appDomain } from './domain/AppDomain';
import { EventNames } from './domain/events/Events';
import "./Promise";
import { RoutingWrapper } from './RoutingWrapper';
import { Wiring } from './wiring/Wiring';

export const wiring = new Wiring();
// appDomain.IRequestLanguageChange.fromCacheOrDefault();
appDomain.IAuthenticationService.loginRedirect();

export class App extends BaseComponent {
    public routingWrapperKey: number = 0;

    constructor(props: {}) {
        super(props);
        this.subscribe(EventNames.loggedIn, this.onLoginOnLogout.bind(this));
        this.subscribe(EventNames.loggedOut, this.onLoginOnLogout.bind(this));
        this.subscribe(EventNames.languageChanged, this.onLanguageChanged.bind(this));
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("componentDidCatch", error, errorInfo);
    }

    componentDidMount() {
        appDomain.IRequestLanguageChange.fromCacheOrDefault().then(() => {
            this.forceUpdate();
        });
    }

    onLoginOnLogout = () => {
        this.routingWrapperKey++;
        setTimeout(() => this.setStateWhenMounted({}), 100);
    };

    onLanguageChanged = () => this.setStateWhenMounted({});

    render() {
        return (
            <HashRouter>
                <RoutingWrapper key={`routing-wrapper-${this.routingWrapperKey}`} />
            </HashRouter>
        )
    }
}

export default App;
